'use client';

import { ReactNode } from 'react';

import { FadeIn } from './FadeIn';

/**
 * Configuration properties for the Accordion component.
 */
interface IAccordionProps {
  /** The content to be displayed inside the accordion. */
  children: ReactNode;
  /** The animation duration in seconds. Defaults to 0.5. */
  delay?: number;
  /** Whether the accordion is currently expanded. */
  isExpanded: boolean;
}

/**
 * A component that animates the height of its children to expand or collapse.
 */
export function AccordionTw({
  children,
  delay = 0.5,
  isExpanded,
}: Readonly<IAccordionProps>) {
  return (
    <FadeIn
      animate={isExpanded ? 'expanded' : 'collapsed'}
      initial={isExpanded ? 'expanded' : 'collapsed'}
      layout
      transition={{ duration: delay }}
      variants={{
        expanded: {
          height: 'auto',
          opacity: 1,
        },
        collapsed: {
          height: 0,
          opacity: 0,
        },
      }}
    >
      {children}
    </FadeIn>
  );
}
